import type { ErroFoody } from "../../../services/integracaoFoodyDelivery"

export type IntegracaoFoodyDeliveryModel = {
    token: string
    erros: ErroFoody[]
    integracaoAtiva: boolean | null
    mensagemTeste: string | null
}

export const IntegracaoFoodyDeliveryInicial: IntegracaoFoodyDeliveryModel = {
    token: "",
    erros: [],
    integracaoAtiva: null,
    mensagemTeste: null,
}
